/**
 * The Call Logs `filter` request block (`/calls`, `/total`, `/export`), reduced to the fields a role's
 * endpoints read. Empty lists, an unset sale and a blank search mean "no restriction" and are left out;
 * returns undefined when nothing restricts, so the request carries no `filter` at all.
 *
 * @param {object} [filter] the page's filter state
 * @param {string[]} fields the filter fields the role sends
 */
export function buildCallLogsFilter(filter, fields) {
  if (!filter) {
    return undefined
  }

  const result = {}

  fields.forEach(field => {
    const value = filter[field]

    if (Array.isArray(value)) {
      if (value.length > 0) {
        result[field] = [...value]
      }
    } else if (typeof value === 'boolean') {
      result[field] = value
    } else if (typeof value === 'string') {
      const trimmed = value.trim()

      if (trimmed) {
        result[field] = trimmed
      }
    }
  })

  return Object.keys(result).length > 0 ? result : undefined
}

export const BUYER_CALL_LOGS_FILTER_FIELDS = Object.freeze(['channels', 'trafficSourceIds', 'campaignIds', 'isSaleReported', 'search'])

export const SELLER_CALL_LOGS_FILTER_FIELDS = Object.freeze(['trafficSourceIds', 'offerIds', 'search'])
